<template>
  <v-flex>
    <v-dialog v-if="this.modelReglaTarifa" v-model="dialogFormularioRegla" :max-width="1400" persistent>
      <regla-formulario :key="formKey" @cerrarFormularioReglaTarifa="_cerrarFormularioReglaTarifa"
        :modelReglaTarifa="this.modelReglaTarifa" :accion="this.accion" />
    </v-dialog>

    <v-dialog v-if="proveedorSelec" v-model="dialogFormularioProveedor" width="1600px" persistent>
      <proveedor-formulario @cerrarFormularioProveedor="dialogFormularioProveedor = false"
        :modelProveedor="proveedorSelec" :accion="'editar'" />
    </v-dialog>

    <v-dialog v-model="showTarifasConPrecio" width="800" persistent>
      <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <span v-bind:style="{ color: 'white' }">Tarifas para la regla: {{ reglaSelec ? reglaSelec.nombre : '' }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showTarifasConPrecio = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text>

          <v-row class="mt-12">
            <v-col>
              <v-data-table v-if="reglaSelec !== null" locale="es" dense :headers="headersTarifas" :items="reglaSelec.tarifas"
                :items-per-page="reglaSelec.tarifas.length"
                class="elevation-1 alternating-rows bordered-table mx-4 mb-6" hide-default-footer>



                <template v-slot:no-data>
                  No hay tarifas disponibles
                </template>

              </v-data-table>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="showConfirmacionEliminacion = false">mdi-close-circle</v-icon>
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar la regla de tarifas?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarRegla()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip label class="ml-4" color="blue-grey darken-3" @click="showConfirmacionEliminacion = false">
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="mt-2 mb-2" color="rgb(250, 250, 250, 1)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-chip label class="mr-2" link :color="'green lighten-1'" @click="_goProveedores">
          <span v-bind:style="{ color: 'white' }">
            Lista de Proveedores
          </span>
        </v-chip>
        <v-toolbar-title :dark="!dark">Reglas de Tarifas</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title :dark="!dark">{{ proveedorSelec ? proveedorSelec.nombre : '' }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-chip label class="mr-4 px-5" link :color="'green lighten-1'" @click="_openEditarProveedor()">
          <span v-bind:style="{ color: 'white' }">
            Editar Proveedor
          </span>
        </v-chip>

        <v-chip label class="mr-1" link :color="colorAccent1" @click="_crearRegla">
          <span v-bind:style="{ color: 'white' }">
            Nueva Regla de Tarifas
          </span>
        </v-chip>
      </v-toolbar>
      <v-card-text>
        <v-container class="px-4 pt-4 pb-4">
          <v-row class="mb-12">
            <v-col>
              <v-data-table locale="es" dense :headers="headersReglas" :items="reglas" :items-per-page="reglas.length"
                class="elevation-1 alternating-rows bordered-table" hide-default-footer>


                <template v-slot:[`item.nombre`]="{ item, index }">
                  <template v-if="index === 0 || item.nombre !== reglas[index - 1].nombre">
                    <v-chip label :color="_getColorTemporada(item.nombre)" class="mr-2" small>
                      {{ item.nombre }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip :color="_getColorTemporada(item.nombre)" class="mr-2" small>
                      
                    </v-chip>
                  </template>
                </template>

                <template v-slot:[`item.dias_dela_semana`]="{ item }">
                  {{ _captionDiasDeLaSemana(item) }}
                </template>

                <template v-slot:[`item.mostrar_precios`]="{ item }">
                  <v-chip label small class="mr-1 mt-1 mb-1" link color="green lighten-2"
                    @click="_showTarifasConPrecio(item)" text-color="white">
                    Mostrar Precios
                  </v-chip>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="_editar(item)">
                      <v-list-item-title>Editar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="_duplicar(item)">
                      <v-list-item-title>Duplicar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="_deleteRegla(item)">
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>

                  </v-list>
                </v-menu>
              </template>


                <template v-slot:no-data>
                  No hay reglas de tarifas por fechas disponibles
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row class="mt-12">

            <v-col>
              <v-row justify="space-between">

                <v-col class="ml-6" cols="8">
                  <v-chip label color="green" class="mr-2" small> Temporada Baja </v-chip>
                  <v-chip label color="blue" class="mr-2" small> Temporada Media </v-chip>
                  <v-chip label color="orange" class="mr-2" small> Temporada Alta </v-chip>
                  <v-chip label color="yellow" class="mr-2" small> Temporada Especial </v-chip>
                  <v-chip label color="red" class="mr-2" small> Cierre </v-chip>
                </v-col>





                

                <v-col cols="3">
               
                  <v-select v-model="selectedYear" :items="years" label="Año" outlined dense></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-for="mes in 12" :key="mes">
                  <mes-calendario-anual :year="selectedYear" :month="mes" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>



        </v-container>
      </v-card-text>
    </v-card>




  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ReglaFormulario from "../components/formularios/ReglaFormulario";
import ProveedorFormulario from "../components/formularios/ProveedorFormulario";

import MesCalendarioAnual from "../components/MesCalendarioAnual.vue";

export default {
  components: {
    ReglaFormulario,
    ProveedorFormulario,
    MesCalendarioAnual,
  },

  data: () => ({

    accion: "",
    formKey: 0,

    selectedYear: 2025,
    years: [2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050],
    selectedDate: null,

    nombresMeses: [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ],


    headersReglas: [
      { text: 'NOMBRE', value: 'nombre' },
      { text: 'FECHA DESDE', value: 'fecha_desde' },
      { text: 'FECHA HASTA', value: 'fecha_hasta' },
      { text: 'DIAS DE LA SEMANA', value: 'dias_dela_semana' },
      { text: '', value: 'mostrar_precios', align: 'end', width: '120px' },
      { text: '', value: 'actions', align: 'end', width: '10px' },
    ],

    headersTarifas: [
      { text: 'REGIMEN', value: 'regimen_titulo' },
      { text: 'HABITACION-CARACTERISTICA', value: 'habitacion_caracteristica_titulo' },
      { text: 'PRECIO', value: 'precio', width: '200px' },
    ],

    dialogFormularioRegla: false,
    modelReglaTarifa: null,
    showConfirmacionEliminacion: false,

    showTarifasConPrecio: false,

    dialogFormularioProveedor: false,
    




  }),

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorFondoDialog",
      "colorBarraFormulario",
      "tiposCliente",
      "loading",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("proveedores", ["proveedorSelec"]),
    ...mapState("reglas", ["reglas", "reglaSelec"]),
  },

  watch: {

  },

  mounted() {
    this._getReglasFromProveedor();
  },

  methods: {
    ...mapActions("reglas", ["getReglasFromProveedor", "eliminarRegla"]),
    ...mapMutations("reglas", ["setReglaSelec"]),

    _inicializarModelRegla() {
      this.modelReglaTarifa = {
        id: null,
        nombre: null,
        fecha_desde: null,
        fecha_hasta: null,
        dia_desde: null,
        dia_hasta: null,
        comentarios: null,
        proveedor_id: this.proveedorSelec.id,
        tarifas: this.proveedorSelec.tarifas
      };

      this.modelReglaTarifa.tarifas.forEach(tarifa => {
        tarifa.precio = '0.00';
      });
    },

    _openEditarProveedor() {
      this.dialogFormularioProveedor = true;
    },

    _cerrarFormularioReglaTarifa() {
      this.dialogFormularioRegla = false;
      this.formKey++;
    },

    _getColorTemporada(nombre) {
      switch (nombre) { 
        case 'Temporada Baja':
          return 'green';
        case 'Temporada Media':
          return 'blue';
        case 'Temporada Alta':
          return 'orange';
        case 'Temporada Especial':
          return 'yellow';
        case 'Cierre':
          return 'red';  
      }
    },

    _captionDiasDeLaSemana(item) {
      var res = "";
      if (item.dia_desde == 0 && item.dia_hasta == 6) {
        res = "Todos los días";
      } else if (item.dia_desde == 1 && item.dia_hasta == 5) {
        res = "De Lunes a Viernes";
      } else if (item.dia_desde == 1 && item.dia_hasta == 4) {
        res = "De Lunes a Jueves";
      } else if (item.dia_desde == 6 && item.dia_hasta == 0) {
        res = "Sábados y Domingos";
      } else if (item.dia_desde == 5 && item.dia_hasta == 0) {
        res = "De Viernes a Domingo";
      }
      return res;
    },

    async _getReglasFromProveedor() {
      if (this.proveedorSelec != null) {
        await this.getReglasFromProveedor([this.access_token, this.proveedorSelec.id, true]);
        console.log(this.reglas);
      }
    },

    _deleteRegla(item) {
      this.setReglaSelec(item);
      this.showConfirmacionEliminacion = true;
    },

    _showTarifasConPrecio(item) {
      this.setReglaSelec(item);
      this.showTarifasConPrecio = true;
    },

    obtenerNombreMes(month) {
      return this.nombresMeses[month - 1]; 
    },

    _goProveedores() {
      this.$router.push('/proveedores');
    },

    _crearRegla() {
      this._inicializarModelRegla();
      this.accion = 'crear';
      this.dialogFormularioRegla = true;
    },

    _editar(item) {
      this.setReglaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.reglaSelec));
      this.modelReglaTarifa = temp;
      this.accion = 'editar';
      this.dialogFormularioRegla = true;
    },

    _duplicar(item) {
      this.setReglaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.reglaSelec));
      this.modelReglaTarifa = temp;
      this.modelReglaTarifa.id = null;
      this.modelReglaTarifa.fecha_desde = null;
      this.modelReglaTarifa.fecha_hasta = null;
      this.accion = 'duplicar';
      this.dialogFormularioRegla = true;
    },

    async _eliminarRegla() {
      this.showConfirmacionEliminacion = false;
      if (this.reglaSelec != null) {
        await this.eliminarRegla([this.access_token, this.reglaSelec.id]);
      }
    },

    rowClass(item, index) {
      return index % 2 === 0 ? 'light-blue-row' : '';
    },
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}


.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

/* Si también quieres líneas horizontales entre las filas */
.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* Si quieres un borde superior para la primera fila */
.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
